import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import React from "react";
import icClock from "../assets/time.svg";

const useStyles = makeStyles(
  () => ({
    root: {
      minWidth: ({ width }) => width,
      maxWidth: ({ width }) => width,
      justifyContent: "flex-start",
      backgroundColor: "#DCE1FF",
      //   borderColor: "none",
      borderRadius: 12,
      "& .MuiChip-avatar": {
        width: 20,
        height: 20,
      },
    },
    label: {
      color: "#2452D6",
      fontSize: 14,
      fontWeight: 400,
      paddingRight: 5,
    },
  }),
  {
    name: "TimerChip",
  },
);

/**
 * @param {String} label
 * @param {Object} classes
 * @param {Object} rest
 */
const NewTimerChip = ({ label, classes, ...rest }) => {
  const _classes = useStyles({ width: label.length > 5 ? 100 : 80 });

  return (
    <Chip
      {...rest}
      label={label}
      classes={{ ...classes, root: _classes.root, label: _classes.label }}
      avatar={<img src={icClock} alt="" />}
      variant="default"
    />
  );
};

NewTimerChip.propTypes = {
  classes: PropTypes.object,
  label: PropTypes.string.isRequired,
};

export default NewTimerChip;
